var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-header bg-transparent text-right" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.showModal.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(" Adicionar Revendedora\n            ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.ExportExcel.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-file-excel" }),
                      _vm._v(" Exportar Revendedoras\n            ")
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("label", [_vm._v("Nome")]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        model: {
                          value: _vm.nome,
                          callback: function($$v) {
                            _vm.nome = $$v
                          },
                          expression: "nome"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("label", [_vm._v("CPF")]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "###.###.###-##",
                            expression: "'###.###.###-##'"
                          }
                        ],
                        model: {
                          value: _vm.cpf,
                          callback: function($$v) {
                            _vm.cpf = $$v
                          },
                          expression: "cpf"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("label", [_vm._v("Situação")]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.optionStatus },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("b-table", {
                        attrs: {
                          items: _vm.showRevendedoras,
                          fields: _vm.headerRevendedoras,
                          "current-page": _vm.currentPage,
                          "per-page": _vm.perPage,
                          "sticky-header": "",
                          "head-variant": "ligth",
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                          stacked: "md",
                          "show-empty": "",
                          "empty-text": "Nenhuma revendedora encontrada",
                          hover: "",
                          bordered: "",
                          borderless: "",
                          striped: "",
                          small: "",
                          busy: _vm.loading
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sortDesc = $event
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-danger my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _vm._v(" "),
                                    _c("strong", [_vm._v("Carregando...")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(id)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.editaRevendedora(row.value)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-edit",
                                      attrs: { title: "Editar" }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                row.item.ativa === false
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "danger",
                                          title: "Excluir"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.deletarRevendedora(
                                              row.value
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-user-times"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "fill",
                          size: "sm"
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            attrs: {
              size: "xl",
              id: "modalRev",
              title: "Cadastro de Revendedora"
            },
            scopedSlots: _vm._u([
              {
                key: "modal-footer",
                fn: function() {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary", size: "sm" },
                        on: { click: _vm.saveRevendedora }
                      },
                      [_vm._v("\n          Salvar\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "danger", size: "sm" },
                        on: {
                          click: function($event) {
                            _vm.isshowModal = false
                          }
                        }
                      },
                      [_vm._v("\n          Cancelar\n        ")]
                    )
                  ]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.isshowModal,
              callback: function($$v) {
                _vm.isshowModal = $$v
              },
              expression: "isshowModal"
            }
          },
          [
            _c("cadastro-revendedora", {
              ref: "revendedora",
              attrs: {
                lista_revendedoras: _vm.revendedoras,
                revendedora: _vm.revendedora,
                classe_distribuidor: _vm.classe,
                "codigo-distribuidor": _vm.getDistributor,
                meu_estado: _vm.estado,
                ismodal: true
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19552610", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19552610","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/revendedora/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-19552610","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/revendedora/Main.vue
// module chunks = 2